import { DEFAULT_PER } from '@/config'
import pull_up from './pull_up'

const DEFAULT_OPTIONS = {
    loading_name: 'loading',
    page_name: 'page',
    items_name: 'items',
    no_more_name: 'no_more',
    per_name: 'per'
}

// 如果不是下拉刷新，则需要在 data 中定义 no_reach_bottom 为 true

// 如果分页不是 DEFAULT_PER 大小，需要在 data 中定义 per

export const getPaginationMixin = (options = DEFAULT_OPTIONS) => {
    const { loading_name, page_name, items_name, no_more_name, per_name } = Object.assign({}, DEFAULT_OPTIONS, options)
    return {
        mixins: [
            pull_up
        ],
        data () {
            return {
                [loading_name]: true,
                [page_name]: 1,
                [items_name]: [],
                [no_more_name]: false,
                no_reach_bottom: false
            }
        },
        beforeDestroy () {
            this.resetPaginationData()
        },
        methods: {
            onPullUp () {
                if (!this[loading_name]) {
                    this.reachBottom()
                }
            },
            resetPaginationData () {
                this[loading_name] = true
                this[page_name] = 1
                this[items_name] = []
                this[no_more_name] = false
            },
            reachBottom () {
                if (!this.no_reach_bottom && !this[no_more_name] && !this[loading_name]) {
                    this[page_name] += 1
                    this.getData()
                }
            },
            handleData (data, options = {}) {
                const { handleItem } = options
                try {
                    this[no_more_name] = data[items_name].length === 0
                        || data[items_name].length < (this[per_name] || DEFAULT_PER)
                    const items = typeof handleItem === 'function' ? data.items.map(handleItem) : data.items
                    if (this.page === 1) {
                        this[items_name] = items
                    } else {
                        this[items_name].push(...items)
                    }
                    this[loading_name] = false
                } catch (err) {
                    console.error(err)
                }
            }
        }
    }
}

export default getPaginationMixin()
